import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=ef50bde2"
import script from "./Deposits.vue?vue&type=script&lang=js"
export * from "./Deposits.vue?vue&type=script&lang=js"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=ef50bde2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports